module.exports = __webpack_public_path__ + "img/om-effect.0e055208.png";